import React from 'react'

const pageImagesTwo = ({ slice }) => {

    return (
        <section className="page-images-two container">
            <div>
                <img src={slice.primary.image_left.url} alt={slice.primary.image_left.alt} />
            </div>
            <div>
                <img src={slice.primary.image_right.url} alt={slice.primary.image_right.alt} />
            </div>
        </section>
    )
}

export default pageImagesTwo